import React from 'react';
import { Button, Card, Input, Select, Switch } from 'antd';
import { Trans, useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { LAST_ORDER_GAP_OPTIONS, ORDER_METHODS } from '../../services/exports/Constants';

export default function PickupTab({ data, toggleMethodVisible, validator, feedback, loading, onChange, onSave }) {
  const { t } = useTranslation(undefined, { keyPrefix: 'Components:Takeout:PickupTab' });

  return (
    <div className="mt-lg">
      <Card className="mb-md">
        <div className="text-base font-semibold mb-md">{t('sections.state.title')}</div>
        <div>
          <div className="mb-md flex items-center">
            <Switch
              id="pickup-visible"
              checked={!data.hidden_order_methods.includes(ORDER_METHODS.pickup)}
              onChange={toggleMethodVisible}
            />
            <label htmlFor="pickup-visible" className="my-auto ml-4 cursor-pointer">
              {t('sections.state.fields.pickup_visible.label')}
            </label>
          </div>
          <div className="mb-md flex items-center">
            <Switch
              id="has-pickup"
              checked={data?.has_pickup}
              onChange={(checked) => onChange('has_pickup', checked)}
            />
            <label htmlFor="has-pickup" className="my-auto ml-4 cursor-pointer">
              {t('sections.state.fields.has_pickup.label')}
            </label>
          </div>
          <Button type="primary" loading={loading} disabled={loading} onClick={onSave} className="my-4">
            {t('buttons.save')}
          </Button>
        </div>
      </Card>
      <Card className="mb-md">
        <div className="text-base font-semibold mb-md">{t('sections.preparation_time_pickup_orders.title')}</div>
        <div>
          <div className="mb-md">
            <label htmlFor="average-order-preparation-time-min">
              {t('sections.preparation_time_pickup_orders.fields.average_order_preparation_time_min.label')}
            </label>
            <div className="flex">
              <Input
                id="average-order-preparation-time-min"
                placeholder={t(
                  'sections.preparation_time_pickup_orders.fields.average_order_preparation_time_min.placeholder',
                )}
                type="number"
                value={data?.average_order_preparation_time_min ?? ''}
                onChange={(e) => onChange('average_order_preparation_time_min', e.target.value)}
                onWheel={(e) => e.target.blur()}
              />
              <label className="my-auto mx-2" htmlFor="average-order-preparation-time-max">
                {t('sections.preparation_time_pickup_orders.fields.average_order_preparation_time_max.label')}
              </label>
              <Input
                id="average-order-preparation-time-max"
                placeholder={t(
                  'sections.preparation_time_pickup_orders.fields.average_order_preparation_time_max.placeholder',
                )}
                type="number"
                value={data?.average_order_preparation_time_max ?? ''}
                onChange={(e) => onChange('average_order_preparation_time_max', e.target.value)}
                onWheel={(e) => e.target.blur()}
              />
            </div>
            <div className="text-sm text-gray-500">
              {validator.message(
                t('sections.preparation_time_pickup_orders.fields.average_order_preparation_time_min.label'),
                data?.average_order_preparation_time_min,
                'required',
              )}
              {feedback?.errors?.average_order_preparation_time_min}{' '}
              {feedback?.errors?.average_order_preparation_time_max}
            </div>
          </div>
          <div className="mb-md">
            <span>
              <Trans t={t}>sections.scheduled_orders.fields.last_order_gap_pickup.label</Trans>
            </span>
            <Select
              id="last-order-gap-pickup"
              className="w-full"
              value={data?.last_order_gap_pickup ?? undefined}
              onChange={(value) => onChange('last_order_gap_pickup', value)}
              options={LAST_ORDER_GAP_OPTIONS.map((item) => ({
                value: item,
                label: t('sections.scheduled_orders.fields.last_order_gap_pickup.option', { value: item }),
              }))}
            />
          </div>
          <Button type="primary" loading={loading} disabled={loading} onClick={onSave} className="my-4">
            {t('buttons.save')}
          </Button>
        </div>
      </Card>
      <Card className="mb-md mt-lg">
        <div className="text-base font-semibold mb-md">{t('sections.scheduled_orders.title')}</div>
        <div>
          <div className="mb-md">
            <Switch
              id="has-scheduled-orders"
              checked={data?.has_scheduled_orders}
              onChange={(checked) => {
                if (!checked && !data?.has_asap_orders) {
                  return toast.error(t('toasts.at_least_one_order_method_required'));
                }

                return onChange('has_scheduled_orders', checked);
              }}
            />
            <label className="ml-4 align-bottom cursor-pointer" htmlFor="has-scheduled-orders">
              {t('sections.scheduled_orders.fields.has_scheduled_orders.label')}
            </label>
            <div className="text-sm text-gray-500">{feedback?.errors?.has_scheduled_orders}</div>
          </div>
          {data?.has_scheduled_orders && (
            <div className="mb-md">
              <span>
                <Trans t={t}>sections.scheduled_orders.fields.min_schedule_ahead_time_pickup.label</Trans>
              </span>
              <Input
                id="min-schedule-ahead-time-pickup"
                type="number"
                placeholder={t('sections.scheduled_orders.fields.min_schedule_ahead_time_pickup.placeholder')}
                value={data?.min_schedule_ahead_time_pickup ?? ''}
                onChange={(e) => onChange('min_schedule_ahead_time_pickup', e.target.value)}
                onWheel={(e) => e.target.blur()}
              />
            </div>
          )}
          <Button type="primary" loading={loading} disabled={loading} onClick={onSave} className="my-4">
            Save
          </Button>
        </div>
      </Card>
    </div>
  );
}
